import { ICampaignVote, ICategoryVote, ITemplateChart } from "api/types/_campaign";
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from "common/toast";
import DropdownCategoryVote from "components/Common/DropdownCategoryVote";
import DropdownOption from "components/Common/DropdownOption";
import InputsRange from "components/Common/InputsRange";
import SearchTemplateChart from "components/Common/SearchTemplateChart";
import TooltipCustom from "components/Common/TooltipCustom";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import { useFormik } from "formik";
import { AI_MODEL_OPTIONS, ENUM_SCHEDULE, SCHEDULE_OPTIONS, SCHEDULE_VOTE_OPTIONS, SCHEDULE_WEEKLY_OPTIONS, TEMPLATE_CATEGORY_TYPE_BOOSTING_CONTENT, TYPE_VOTE_OPTIONS, VOTE_CYCLE_TYPE } from "helpers/constans";
import moment from "moment";
import React, { useEffect, useState } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import { useTranslation } from "react-i18next";
import JSONPretty from "react-json-pretty";
import { toast } from "react-toastify";
import { Col, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from "reactstrap";
import { postCampaignVoteKeyword, putCampaignVoteKeyword } from "store/campaign/thunk";
import * as Yup from "yup";

export interface Props {
    isOpen?: boolean;
    detail?: ICampaignVote | null,
    sources?: { label: string, value: string, name: string }[],
    partners?: { label: string, value: string, name: string, partner_codes?: any[], partner_reporters?: any[] }[],
    templateSubject?: { label: string, value: string }[],
    templateBody?: { label: string, value: string, category?: number }[],
    categoryVote?: ICategoryVote[],
    // templateChart?: ITemplateChart[],
    onClose?: () => void
    triggerRefresh?: (type?: string) => void;
}

registerLocale("en", en);
registerLocale("ko", ko);

const FILE_SIZE = 11 * 1024 * 1024; // 11MB
const SUPPORTED_FORMATS = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/svg+xml'];

const CampaignForm = ({
    isOpen = false,
    detail = null,
    sources = [],
    partners = [],
    templateSubject = [],
    templateBody = [],
    categoryVote = [],
    // templateChart = [],
    onClose,
    triggerRefresh
}: Props) => {
    const { t, i18n } = useTranslation();

    const AI_MODEL_OPTIONS_LANG: any = AI_MODEL_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const TYPE_VOTE_OPTIONS_LANG: any = TYPE_VOTE_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));


    const SCHEDULE_OPTIONS_LANG: any = SCHEDULE_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const SCHEDULE_VOTE_OPTIONS_LANG: any = SCHEDULE_VOTE_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const SCHEDULE_WEEKLY_OPTIONS_LANG: any = SCHEDULE_WEEKLY_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const SOURCE_OPTIONS_LANG: any = sources;

    const MEDIA_OPTIONS_LANG: any = partners;

    const TEMPLATE_SUBJECT_OPTIONS_LANG: any = templateSubject;

    const TEMPLATE_BODY_ONGOING_OPTIONS_LANG: any = templateBody?.filter((_c) => String(_c?.category) === String(TEMPLATE_CATEGORY_TYPE_BOOSTING_CONTENT.ONGOING_VOTE_KEYWORD));

    const TEMPLATE_BODY_COMPLETED_OPTIONS_LANG: any = templateBody?.filter((_c) => String(_c?.category) === String(TEMPLATE_CATEGORY_TYPE_BOOSTING_CONTENT.COMPLETED_VOTE_KEYWORD));

    // const TEMPLATE_CHART_OPTIONS_LANG: any = templateChart?.map((tmpl: any, index: number) => ({ id: String(tmpl?.id), name: tmpl?.name, name_korea: tmpl?.name_korea, code: tmpl?.code, image_url: tmpl?.image_url }));;

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [isDetailLoading, setIsDetailLoading] = useState<boolean>(false);

    const [isLoadingPreviewJSON, setIsLoadingPreviewJSON] = useState<boolean>(false);

    const [isShowPreviewJSON, setIsShowPreviewJSON] = useState<boolean>(false);

    const [jsonSources, setJsonSources] = useState<any[]>([]);

    const onCloseClick = () => {
        onClose && onClose();
    }

    const handleSubmit = async (values: any) => {
        try {
            setIsLoading((_prev) => true);

            const data = {
                name: values?.name || '',
                // keyword: values?.keyword || '',

                // category_ids: (values?.category_ids || [])?.map((v: any, index: number) => Number(v?.value)) || [],

                medias: (values?.media_ids || [])?.map((v: any, index: number) => ({
                    media_id: Number(v?.value),
                    media_code_id: Number((values?.section_ids || [])?.[index]?.value),
                    media_reporter_id: (values?.reporter_ids || [])?.[index] || '',
                    // reporter_by_line: (values?.reporter_by_lines || [])?.[index] || '',
                    is_auto_publish: Number((values?.is_auto_publishes || [])?.[index]),
                })) || [],

                // title_template_id: Number(values?.title_template_id?.value || TEMPLATE_SUBJECT_OPTIONS_LANG[0]?.value),

                // graphic_info_code: values?.chart_template_code?.value || TEMPLATE_CHART_OPTIONS_LANG[0]?.value,

                // vote_type: Number(values?.vote_type?.value || TYPE_VOTE_OPTIONS_LANG[0]?.value),
                // cycle_type: Number(values?.cycle_type?.value || SCHEDULE_VOTE_OPTIONS_LANG[0]?.value),

                times: (values?.create_schedules || [])?.map((_sch: any) => ({
                    type: _sch?.type ? Number(_sch?.type) : ENUM_SCHEDULE.EVERY_DAY,
                    time: _sch?.time,
                    ...(_sch?.type === ENUM_SCHEDULE.EVERY_WEEK ? { day_of_week: Number(_sch?.date || SCHEDULE_WEEKLY_OPTIONS_LANG[0]?.value) } : {})
                })),

                daily_search_volume_start: Number(values?.daily_search_volume_start || 0),
                daily_search_volume_end: Number(values?.daily_search_volume_end || 0),

                ongoing_vote_prompt: values?.ongoing_vote_prompt || '',
                completed_vote_prompt: values?.completed_vote_prompt || '',

                ongoing_vote_body_template_id: Number(values?.ongoing_vote_body_template_id?.value || TEMPLATE_BODY_ONGOING_OPTIONS_LANG[0]?.value),
                completed_vote_body_template_id: Number(values?.completed_vote_body_template_id?.value || TEMPLATE_BODY_COMPLETED_OPTIONS_LANG[0]?.value),

                ai_model: values?.ai_model?.value || AI_MODEL_OPTIONS_LANG[1]?.value,

                support_message_prompt: values?.support_message_prompt || '',
                support_message_ai_model: values?.support_message_ai_model?.value || AI_MODEL_OPTIONS_LANG[1]?.value,
            };
            const response: any = !!detail?.id ? await putCampaignVoteKeyword(detail?.id, data) : await postCampaignVoteKeyword(data);
            if (response?.code === 200) {
                setIsLoading((_prev) => false);
                toast(
                    `${t("The process has been completed.")}`,
                    CONFIG_OPTION_TOAST_NORMAL
                );
                triggerRefresh && triggerRefresh(!!values?.is_show_create_reporter ? 'REFRESH_MEDIA' : '');
            } else {
                setIsLoading((_prev) => false);
                toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsLoading((_prev) => false);
            toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    const validationSchema = Yup.object({
        name: Yup.string().required(`${t("This is required")}`),

        daily_search_volume_start: Yup.string().required(`${t("This is required")}`),

        daily_search_volume_end: Yup.string().required(`${t("This is required")}`),

        // gold_price_source_ids: Yup.array().of(Yup.object().shape({
        //     label: Yup.string(),
        //     value: Yup.string(),
        // })).nullable(),

        media_ids: Yup.array().of(Yup.object().shape({
            label: Yup.string(),
            value: Yup.string(),
        }).required(`${t("This is required")}`)).required(`${t("This is required")}`),

        section_ids: Yup.array().of(Yup.object().shape({
            label: Yup.string(),
            value: Yup.string(),
        }).required(`${t("This is required")}`)).required(`${t("This is required")}`),

        reporter_ids: Yup.array().of(Yup.string().nullable()).nullable(),

        // reporter_by_lines: Yup.array().of(Yup.string().nullable()).nullable(),

        is_auto_publishes: Yup.array().of(Yup.number().nullable()).nullable(),

        // category_ids: Yup.array().of(Yup.object().shape({
        //     label: Yup.string(),
        //     value: Yup.string().required(`${t("This is required")}`),
        // }).required(`${t("This is required")}`)).required(`${t("This is required")}`),

        // emails: Yup.array().of(
        //     Yup.object().shape({
        //         id: Yup.string(),
        //         text: Yup.string().email(t('Invalid email format'))
        //     })
        // ).nullable(),

        is_auto_publish: Yup.number().nullable(),

        ongoing_vote_prompt: Yup.string().nullable(),

        completed_vote_prompt: Yup.string().nullable(),

        times: Yup.array().of(Yup.string().nullable()).nullable(),

        // vote_type: Yup.object().shape({
        //     label: Yup.string(),
        //     value: Yup.string(),
        // }).required(`${t("This is required")}`),

        // cycle_type: Yup.object().shape({
        //     label: Yup.string(),
        //     value: Yup.string(),
        // }).required(`${t("This is required")}`),

        create_schedules: Yup.array().of(
            Yup.object().shape({
                type: Yup.string().nullable(),
                date: Yup.string().nullable(),
                // .when(['$cycle_type'], (_cycle_type: any, schema) => {
                //     return _cycle_type?.[0]?.value === VOTE_CYCLE_TYPE.WEEKLY ? schema.required(t('Date is required')) : schema.notRequired();
                // }),
                time: Yup.string().required(t('Time is required')),
            })
        ).nullable(),

        // publish_schedules: Yup.array().of(
        //     Yup.object().shape({
        //         type: Yup.string().required('Type is required'),
        //         date: Yup.string().when('type', {
        //             is: (_type: any) => (_type === 'weekly'),
        //             then: (schema: any) => schema.required('Date is required'),
        //             otherwise: (schema: any) => schema.notRequired(),
        //         }),
        //         time: Yup.string().required('Time is required'),
        //     })
        // ).nullable(),

        ai_model: Yup.object().shape({
            label: Yup.string(),
            value: Yup.string(),
        }), // .required(`${t("This is required")}`)

        // title_template_id: Yup.object().shape({
        //     label: Yup.string(),
        //     value: Yup.string(),
        // }).required(`${t("This is required")}`),

        support_message_prompt: Yup.string().nullable(),
        support_message_ai_model: Yup.object().shape({
            label: Yup.string(),
            value: Yup.string(),
        }),

        ongoing_vote_body_template_id: Yup.object().shape({
            label: Yup.string(),
            value: Yup.string().required(`${t("This is required")}`),
        }).required(`${t("This is required")}`),

        completed_vote_body_template_id: Yup.object().shape({
            label: Yup.string(),
            value: Yup.string().required(`${t("This is required")}`),
        }).required(`${t("This is required")}`),

        // chart_template_code: Yup.object().shape({
        //     label: Yup.string(),
        //     value: Yup.string(),
        // }).required(`${t("This is required")}`),

        // image_urls: Yup.array().of(Yup.object().shape({
        //     filepath: Yup.string(),
        //     url: Yup.string(),
        // })).nullable(),

        // files: Yup.array()
        //     .of(
        //         Yup.mixed()
        //             .test(
        //                 'fileSize',
        //                 t('File too large. Max size is 10MB.'),
        //                 (value: any) => !value || (value?.size <= FILE_SIZE)
        //             )
        //             .test(
        //                 'fileFormat',
        //                 t('Unsupported Format. Please upload an Image file.'),
        //                 (value: any) => !value || SUPPORTED_FORMATS.includes(value?.type)
        //             )
        //     ).nullable(),
        // .when("image_urls", {
        //     is: (image_urls: any) => !image_urls || image_urls?.length === 0,
        //     then: (schema) => schema.min(1, t('Please select at least 1 image')),
        //     otherwise: (schema) => schema.notRequired(),
        // }),
    });

    const formik = useFormik({
        initialValues: {
            name: '',
            daily_search_volume_start: '1000',
            daily_search_volume_end: '10000',
            // gold_price_source_ids: [],
            media_ids: null,
            section_ids: null,
            reporter_ids: null,
            // reporter_by_lines: null,
            // category_ids: null,
            is_auto_publishes: null,
            // image_urls: [],
            // files: [],
            // emails: [],
            // is_auto_publish: 0,
            ongoing_vote_prompt: '',
            completed_vote_prompt: '',
            ai_model: AI_MODEL_OPTIONS_LANG[1],

            support_message_prompt: '',
            support_message_ai_model: AI_MODEL_OPTIONS_LANG[1],
            // title_template_id: null,
            ongoing_vote_body_template_id: null,
            completed_vote_body_template_id: null,
            // chart_template_code: null,
            times: [],

            // vote_type: TYPE_VOTE_OPTIONS_LANG[0],
            // cycle_type: SCHEDULE_VOTE_OPTIONS_LANG[0],
            create_schedules: [],
            // publish_schedules: []
        },
        validationSchema,
        onSubmit: handleSubmit,
    });

    const CREATE_SCHEDULE_DEFAULT = [{ type: SCHEDULE_OPTIONS_LANG[0]?.value, date: '', time: '03:00' }];
    // const PUBLISH_SCHEDULE_DEFAULT = [{ type: SCHEDULE_OPTIONS_LANG[0]?.value, date: '', time: '03:00' }];

    const CREATE_MEDIA_DEFAULT = MEDIA_OPTIONS_LANG[0];

    // const handleAddCategory = (index: number) => {
    //     const mediaIdArray = [...(formik.values.category_ids || []), (formik.values.category_ids || [])[(formik.values.category_ids || [])?.length - 1] || null];
    //     formik.setFieldValue("category_ids", mediaIdArray);
    // };

    // const handleRemoveCategory = (index: number) => {
    //     const mediaIdArray = (formik.values.category_ids || [])?.filter((_m, ind: number) => ind !== index);
    //     formik.setFieldValue("category_ids", mediaIdArray);
    // };

    const handleAddMedia = (index: number) => {
        const mediaIdArray = [...(formik.values.media_ids || []), (formik.values.media_ids || [])[(formik.values.media_ids || [])?.length - 1] || null];
        const sectionIdArray = [...(formik.values.section_ids || []), (formik.values.section_ids || [])[(formik.values.section_ids || [])?.length - 1] || null];
        const reporterIdArray = [...(formik.values.reporter_ids || []), (formik.values.reporter_ids || [])[(formik.values.reporter_ids || [])?.length - 1] || ''];
        const isAutoPublishArray = [...(formik.values.is_auto_publishes || []), (formik.values.is_auto_publishes || [])[(formik.values.is_auto_publishes || [])?.length - 1] || false];
        formik.setFieldValue("media_ids", mediaIdArray);
        formik.setFieldValue("section_ids", sectionIdArray);
        formik.setFieldValue("reporter_ids", reporterIdArray);
        formik.setFieldValue("is_auto_publishes", isAutoPublishArray);
    };

    const handleRemoveMedia = (index: number) => {
        const mediaIdArray = (formik.values.media_ids || [])?.filter((_m, ind: number) => ind !== index);
        const sectionIdArray = (formik.values.section_ids || [])?.filter((_m, ind: number) => ind !== index);
        const reporterIdArray = (formik.values.reporter_ids || [])?.filter((_m, ind: number) => ind !== index);
        const isAutoPublishArray = (formik.values.is_auto_publishes || [])?.filter((_m, ind: number) => ind !== index);
        formik.setFieldValue("media_ids", mediaIdArray);
        formik.setFieldValue("section_ids", sectionIdArray);
        formik.setFieldValue("reporter_ids", reporterIdArray);
        formik.setFieldValue("is_auto_publishes", isAutoPublishArray);
    };

    // const handleAddTime = (index: number) => {
    //     const timeArray = [...(formik.values.times || []), (formik.values.times || [])[(formik.values.times || [])?.length - 1] || '09:00'];
    //     formik.setFieldValue("times", timeArray);
    // };

    // const handleRemoveTime = (index: number) => {
    //     const timeArray = (formik.values.times || [])?.filter((_m, ind: number) => ind !== index);
    //     formik.setFieldValue("times", timeArray);
    // };

    const handleAddCreateSchedule = (index: number) => {
        const timeArray = [...(formik.values.create_schedules || []), (formik.values.create_schedules || [])[(formik.values.create_schedules || [])?.length - 1] || CREATE_SCHEDULE_DEFAULT];
        formik.setFieldValue("create_schedules", timeArray);
    };

    const handleRemoveCreateSchedule = (index: number) => {
        const timeArray = (formik.values.create_schedules || [])?.filter((_m, ind: number) => ind !== index);
        formik.setFieldValue("create_schedules", timeArray);
    };

    // const handleAddPublishSchedule = (index: number) => {
    //     const timeArray = [...(formik.values.publish_schedules || []), (formik.values.publish_schedules || [])[(formik.values.publish_schedules || [])?.length - 1] || PUBLISH_SCHEDULE_DEFAULT];
    //     formik.setFieldValue("publish_schedules", timeArray);
    // };

    // const handleRemovePublishSchedule = (index: number) => {
    //     const timeArray = (formik.values.publish_schedules || [])?.filter((_m, ind: number) => ind !== index);
    //     formik.setFieldValue("publish_schedules", timeArray);
    // };


    // const handleChangeFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     const files = event.target.files;
    //     if (files && files.length > 0) {
    //         const fileArray = Array.from(files);
    //         formik.setFieldValue("files", [...formik.values.files, ...fileArray]);
    //     } else {
    //         formik.setFieldValue("files", []);
    //     }
    // };

    // const handleDeleteFile = (index: number) => {
    //     if (isLoading) {
    //         return;
    //     }
    //     const fileArray = formik.values.files?.filter((f, i) => i !== index);
    //     formik.setFieldValue("files", fileArray);
    // }

    // const handleDeleteImageUrl = (index: number) => {
    //     if (isLoading) {
    //         return;
    //     }
    //     const imageArray = formik.values.image_urls?.filter((f, i) => i !== index);
    //     formik.setFieldValue("image_urls", imageArray);
    // }

    useEffect(() => {
        const handleCallAllOption = async () => {
            try {
                if (!!detail?.id) {
                    const _name = detail?.name || '';

                    const _daily_search_volume_start = detail?.daily_search_volume_start || '0';
                    const _daily_search_volume_end = detail?.daily_search_volume_end || '0';

                    const _sources = (detail?.gold_price_sources || [])?.map((_s: any) => ({ value: String(_s?.id), label: _s?.name }));

                    const _media_ids = detail?.medias?.map((m: any) => (String(m?.id)));
                    const _medias_v = MEDIA_OPTIONS_LANG?.filter((_m: any) => (_media_ids || [])?.includes(String(_m?.value)));
                    const _medias = !!_medias_v?.length ? _medias_v : [{}];
                    const _sections = !!_medias_v?.length ? detail?.medias?.map((_m: any) => ({
                        label: _m?.media_code?.section_title,
                        value: String(_m?.media_code?.id)
                    })) : [{}];

                    const _reporters = !!_medias_v?.length ? detail?.medias?.map((_m: any) => String(_m?.media_reporter_id || '')) : [''];

                    // const _reporter_by_lines = !!_medias_v?.length ? detail?.medias?.map((_m: any) => String(_m?.reporter_by_line || '')) : [''];

                    // const _categories = detail?.categories?.length ? detail?.categories?.map((_c: any) => ({
                    //     id: `${_c?.category_id}`,
                    //     value: `${_c?.category_id}`,
                    //     label: ''
                    // })) : [{ value: '' }];

                    // const _emails = (detail?.emails || [])?.map((e: string) => ({ id: e, text: e }));
                    const _is_auto_publishes = !!_medias_v?.length ? detail?.medias?.map((_m: any) => (Number(_m?.is_auto_publish || 0))) : [0];

                    const _ongoing_vote_prompt = detail?.ongoing_vote_prompt || '';
                    const _completed_vote_prompt = detail?.completed_vote_prompt || '';

                    const _times = (detail?.campaign_schedules || [])?.map((_s: any) => (`${String(_s?.time || '')?.split(':')[0]}:${String(_s?.time || '')?.split(':')[1]}`));

                    const _ai_model = AI_MODEL_OPTIONS_LANG?.find((_m: any) => (String(detail?.ai_model) === String(_m?.value)));
                    // const _image_urls = detail?.images || [];

                    const _support_message_prompt = detail?.support_message_prompt || '';
                    const _support_message_ai_model = AI_MODEL_OPTIONS_LANG?.find((_m: any) => (String(detail?.support_message_ai_model) === String(_m?.value)));

                    // const _title_template_id = TEMPLATE_SUBJECT_OPTIONS_LANG?.find((_m: any) => (String(detail?.title_template?.id) === String(_m?.value)));
                    const _ongoing_vote_body_template_id = TEMPLATE_BODY_ONGOING_OPTIONS_LANG?.find((_m: any) => (String(detail?.ongoing_vote_body_template?.id) === String(_m?.value)));
                    const _completed_vote_body_template_id = TEMPLATE_BODY_COMPLETED_OPTIONS_LANG?.find((_m: any) => (String(detail?.completed_vote_body_template?.id) === String(_m?.value)));
                    // const _chart_template_code = { value: TEMPLATE_CHART_OPTIONS_LANG?.find((_m: any) => (String(detail?.graphic_info?.code) === String(_m?.code)))?.code, label: '' };

                    // const _vote_type = TYPE_VOTE_OPTIONS_LANG?.find((_v: any) => (String(detail?.vote_type) === String(_v?.value)));
                    // const _cycle_type = SCHEDULE_VOTE_OPTIONS_LANG?.find((_v: any) => (String(detail?.cycle_type) === String(_v?.value)));

                    const _create_schedules = (detail?.campaign_schedules || [])?.map((_sch: any) => ({
                        type: SCHEDULE_OPTIONS_LANG?.find((_v: any) => (String(_sch?.type) === String(_v?.value)))?.value || SCHEDULE_OPTIONS_LANG[0]?.value,
                        date: SCHEDULE_WEEKLY_OPTIONS_LANG?.find((_v: any) => (String(_sch?.day_of_week) === String(_v?.value)))?.value,
                        time: (`${String(_sch?.time || '')?.split(':')[0] || ''}:${String(_sch?.time || '')?.split(':')[1] || ''}`),
                    }));

                    setTimeout(() => {
                        formik.setFieldValue('name', _name);
                        formik.setFieldValue('daily_search_volume_start', _daily_search_volume_start);
                        formik.setFieldValue('daily_search_volume_end', _daily_search_volume_end);
                        // formik.setFieldValue('gold_price_source_ids', _sources);
                        formik.setFieldValue('media_ids', _medias);
                        formik.setFieldValue('section_ids', _sections);
                        formik.setFieldValue('reporter_ids', _reporters);
                        // formik.setFieldValue('reporter_by_lines', _reporter_by_lines);
                        // formik.setFieldValue('category_ids', _categories);
                        // formik.setFieldValue('emails', _emails);
                        formik.setFieldValue('is_auto_publishes', _is_auto_publishes);
                        formik.setFieldValue('ongoing_vote_prompt', _ongoing_vote_prompt);
                        formik.setFieldValue('completed_vote_prompt', _completed_vote_prompt);
                        formik.setFieldValue('ai_model', _ai_model);

                        formik.setFieldValue('support_message_prompt', _support_message_prompt);
                        formik.setFieldValue('support_message_ai_model', _support_message_ai_model);
                        // formik.setFieldValue('title_template_id', _title_template_id);
                        formik.setFieldValue('ongoing_vote_body_template_id', _ongoing_vote_body_template_id);
                        formik.setFieldValue('completed_vote_body_template_id', _completed_vote_body_template_id);
                        // formik.setFieldValue('chart_template_code', _chart_template_code);
                        // formik.setFieldValue('vote_type', _vote_type);
                        // formik.setFieldValue('cycle_type', _cycle_type);
                        formik.setFieldValue('create_schedules', _create_schedules);
                        formik.setFieldValue('times', _times);
                        // formik.setFieldValue('image_urls', _image_urls);
                        // formik.setFieldValue('files', []);
                    }, 300);
                } else {
                    formik.setFieldValue('name', '');
                    formik.setFieldValue('daily_search_volume_start', '1000');
                    formik.setFieldValue('daily_search_volume_end', '10000');
                    // formik.setFieldValue('gold_price_source_ids', null);
                    formik.setFieldValue('media_ids', [MEDIA_OPTIONS_LANG[0]]);
                    formik.setFieldValue('section_ids', [
                        {
                            value: String(MEDIA_OPTIONS_LANG[0]?.partner_codes?.[0]?.id),
                            label: MEDIA_OPTIONS_LANG[0]?.partner_codes?.[0]?.section_title,
                        }
                    ]);
                    formik.setFieldValue('reporter_ids', ['']);
                    // formik.setFieldValue('reporter_by_lines', ['']);
                    // formik.setFieldValue('category_ids', [{ value: '' }]);
                    formik.setFieldValue('is_auto_publishes', [0]);
                    // formik.setFieldValue('emails', []);
                    formik.setFieldValue('ongoing_vote_prompt', '');
                    formik.setFieldValue('completed_vote_prompt', '');
                    formik.setFieldValue('times', ['09:00']);
                    formik.setFieldValue('ai_model', AI_MODEL_OPTIONS_LANG[1]);

                    formik.setFieldValue('support_message_prompt', '');
                    formik.setFieldValue('support_message_ai_model', AI_MODEL_OPTIONS_LANG[1]);
                    // formik.setFieldValue('title_template_id', null);
                    formik.setFieldValue('ongoing_vote_body_template_id', null);
                    formik.setFieldValue('completed_vote_body_template_id', null);
                    // formik.setFieldValue('chart_template_code', null);
                    // formik.setFieldValue('vote_type', TYPE_VOTE_OPTIONS_LANG[0]);
                    // formik.setFieldValue('cycle_type', SCHEDULE_VOTE_OPTIONS_LANG[0]);
                    // formik.setFieldValue('image_urls', []);
                    // formik.setFieldValue('files', []);
                    formik.setFieldValue('create_schedules', CREATE_SCHEDULE_DEFAULT);
                    // formik.setFieldValue('publish_schedules', PUBLISH_SCHEDULE_DEFAULT);
                    setTimeout(() => {
                        formik.setErrors({});
                    }, 300);
                }
            } catch (error: any) {
                // setIsLoadingDetail((_prev) => false);

                return error;
            }
        };
        handleCallAllOption();
    }, [JSON.stringify(detail), JSON.stringify(MEDIA_OPTIONS_LANG)]);


    const handlePreviewSourceJSON = async () => {
        try {

        } catch (error: any) {
            setIsLoadingPreviewJSON((_prev) => false);
            toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    // useEffect(() => {
    //     if ((formik?.values?.gold_price_source_ids as any)?.length > 0) {

    //     } else {
    //         setJsonSources((_prev) => ([]));
    //     }

    // }, [JSON.stringify(formik?.values?.gold_price_source_ids)]);

    return (
        <React.Fragment>
            <Modal
                isOpen={isOpen}
                centered={true}
                size="lg"
                // className={`border-header-footer`}
                scrollable={false}
                toggle={onCloseClick}
                keyboard={true}
            >
                <ModalHeader toggle={onCloseClick} className="modal-title-flex-grow-1 pb-2" style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <div className="d-flex flex-column gap-0 gap-sm-2 fs-18 fs-md-20">
                        <div className="flex-grow-1">
                            <>{!!detail?.id ? t('Button Update Campaign') : t('Button Create Campaign')}</>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody className="position-relative">
                    <div>
                        <form onSubmit={formik.handleSubmit}>
                            <Row>
                                <Col sm={12} className="mb-3">
                                    <Label htmlFor="name" className="form-label">{t('Name')} <span className="text-danger"> *</span></Label>
                                    <Input
                                        name="name"
                                        type="text"
                                        className="form-control"
                                        id="name"
                                        placeholder={t('Name')}
                                        value={formik?.values?.name || ''}
                                        onChange={(event: any) => formik.setFieldValue('name', event?.target?.value)}
                                    />
                                    {formik.touched.name && formik.errors.name ? (
                                        <div className="text-danger mt-2">{formik.errors.name}</div>
                                    ) : null}
                                </Col>

                                {/* <Col sm={12} className="mb-3">
                                    <Label htmlFor="gold_price_source_ids" className="form-label">{t('Source')} ({t('Multi')})<span className="text-danger"> *</span></Label>
                                    <DropdownMultiOption
                                        name="gold_price_source_ids"
                                        dataList={SOURCE_OPTIONS_LANG}
                                        placeholder={`${t("Source")}...`}
                                        className="search-filter-category-type dropdown-status-rounded"
                                        classNamePrefix="name-prefix"
                                        initialValue={formik?.values?.gold_price_source_ids || null}
                                        onChangeSelect={(e: any) => {
                                            formik.setFieldValue('gold_price_source_ids', e)
                                        }}
                                        isHasOptionAll={false}
                                        disabled={isDetailLoading}
                                    />
                                    {formik.touched.gold_price_source_ids && formik.errors.gold_price_source_ids ? (
                                        <div className="text-danger mt-2">{formik.errors.gold_price_source_ids}</div>
                                    ) : null}

                                    <div className="mt-2 text-start">
                                        <Link to={''} onClick={(e: any) => { e?.stopPropagation(); e?.preventDefault(); handlePreviewSourceJSON() }} className={`d-flex gap-2 ${(formik?.values?.gold_price_source_ids || [])?.length > 0 ? 'text-primary' : 'text-secondary'}`}>{isLoadingPreviewJSON ? <div style={{ transform: 'translateY(0px)', width: '13px', height: '13px' }}><Spinner size="sm"></Spinner></div> : <div style={{ transform: 'translateY(-1px)', width: '13px', height: '13px' }}> <i className="ri ri-eye-2-line fs-16"></i> </div>} {t('Preview the sample source data JSON')}</Link>
                                    </div>
                                </Col> */}

                                <Col sm={12} className="mb-3">
                                    <Label htmlFor="ongoing_vote_body_template_id" className="form-label">{t('Body Template')} ({t('Ongoing Vote')})<span className="text-danger"> *</span></Label>
                                    <DropdownOption
                                        name="ongoing_vote_body_template_id"
                                        dataList={TEMPLATE_BODY_ONGOING_OPTIONS_LANG}
                                        placeholder={`${t("Body Template")}...`}
                                        className="search-filter-category-type dropdown-status-rounded"
                                        classNamePrefix="name-prefix"
                                        initialValue={formik?.values?.ongoing_vote_body_template_id || null}
                                        onChangeSelect={(e: any) => {
                                            formik.setFieldValue('ongoing_vote_body_template_id', e)
                                        }}
                                        isHasOptionAll={false}
                                        disabled={isDetailLoading}
                                    />
                                    {formik.touched.ongoing_vote_body_template_id && formik.errors.ongoing_vote_body_template_id ? (
                                        <div className="text-danger mt-2">{formik.errors.ongoing_vote_body_template_id}</div>
                                    ) : null}
                                </Col>

                                <Col sm={12} className="mb-3">
                                    <Label htmlFor="completed_vote_body_template_id" className="form-label">{t('Body Template')} ({t('Ended Vote')})<span className="text-danger"> *</span></Label>
                                    <DropdownOption
                                        name="completed_vote_body_template_id"
                                        dataList={TEMPLATE_BODY_COMPLETED_OPTIONS_LANG}
                                        placeholder={`${t("Body Template")}...`}
                                        className="search-filter-category-type dropdown-status-rounded"
                                        classNamePrefix="name-prefix"
                                        initialValue={formik?.values?.completed_vote_body_template_id || null}
                                        onChangeSelect={(e: any) => {
                                            formik.setFieldValue('completed_vote_body_template_id', e)
                                        }}
                                        isHasOptionAll={false}
                                        disabled={isDetailLoading}
                                    />
                                    {formik.touched.completed_vote_body_template_id && formik.errors.completed_vote_body_template_id ? (
                                        <div className="text-danger mt-2">{formik.errors.completed_vote_body_template_id}</div>
                                    ) : null}
                                </Col>

                                <Col sm={12} className="mb-4">
                                    <Label htmlFor="daily_search_volume" className="form-label">{t('Daily Search Volume')} <span className="text-danger"> *</span></Label>
                                    <InputsRange
                                        nameFrom="from"
                                        nameTo="to"
                                        valueFrom={formik?.values?.daily_search_volume_start}
                                        valueTo={formik?.values?.daily_search_volume_end}
                                        placeholderFrom={`${t('Start')}...`}
                                        placeholderTo={`${t('End')}...`}
                                        labelFrom={`${t('Start')}`}
                                        labelTo={`${t('End')}`}
                                        isTypeNumber={true}
                                        onChangeFrom={(val) => formik.setFieldValue("daily_search_volume_start", val)}
                                        onChangeTo={(val) => formik.setFieldValue("daily_search_volume_end", val)}
                                    />
                                    {((formik.touched.daily_search_volume_start && formik.errors.daily_search_volume_start) || (formik.touched.daily_search_volume_end && formik.errors.daily_search_volume_end)) ? (
                                        <div className="text-danger mt-2">{formik.errors.daily_search_volume_start || formik.errors.daily_search_volume_end}</div>
                                    ) : null}
                                </Col>

                                {/* <div className="d-flex flex-column mb-4 pt-3 position-relative" style={{
                                    border: '1px dashed var(--vz-primary)',
                                    borderRadius: '4px',
                                }}>
                                    <span className="text-primary position-absolute fs-13 px-1" style={{ backgroundColor: "var(--vz-secondary-bg)", top: '0px', transform: 'translateY(-50%)' }}>{t('Category')}</span>
                                    {
                                        (formik?.values?.category_ids || [])?.map((_c: any, indx: number) => (

                                            <Col sm={12} className="mb-3 d-flex align-items-end">
                                                <div className="position-relative w-100">
                                                    <Label htmlFor={`category_id_${indx}`} className="form-label">{indx + 1}. {t('Category')}<span className="text-danger"> *</span> </Label>
                                                    <DropdownCategoryVote
                                                        name={`category_id_${indx}`}
                                                        placeholder={t('Category')}
                                                        isClearable={false}
                                                        dataList={categoryVote as any}
                                                        initialValue={_c || undefined}
                                                        onChangeCategory={(event) => {
                                                            formik.setFieldValue(`category_ids[${indx}]`, event)
                                                        }}
                                                        className="dropdown-status-rounded"
                                                        classNamePrefix="name-prefix"
                                                    />
                                                    {(formik.touched.category_ids as any)?.[indx] && (formik.errors.category_ids?.[indx] as any)?.value ? (
                                                        <div className="text-danger mt-2">{(formik.errors.category_ids?.[indx] as any)?.value || ''}</div>
                                                    ) : null}
                                                </div>
                                                <div className="d-flex align-items-center justify-content-end" style={{ width: '125px', paddingBottom: (formik.touched.category_ids as any)?.[indx] && (formik.errors.category_ids?.[indx] as any)?.value ? '26px' : '0px' }} >
                                                    {(((formik?.values?.category_ids as any)?.length > 1)) && <button type="button" className="btn btn-md btn-soft-danger edit-item-btn"
                                                        onClick={(e: any) => { e.stopPropagation(); handleRemoveCategory(indx); }}
                                                    ><i className="ri-close-fill align-bottom"></i></button>
                                                    }
                                                    {((formik?.values?.category_ids as any)?.length === (indx + 1)) && <button type="button" className="btn btn-md btn-soft-success edit-item-btn ms-2"
                                                        onClick={(e: any) => { e.stopPropagation(); handleAddCategory(indx); }}
                                                    ><i className="ri-add-fill align-bottom"></i></button>}
                                                </div>
                                            </Col>
                                        ))}
                                </div> */}

                                <div className="d-flex flex-column mb-4 pt-4 pb-1 position-relative" style={{
                                    border: '1px dashed var(--vz-primary)',
                                    borderRadius: '4px',
                                }}>
                                    <span className="text-primary position-absolute fs-13 px-1" style={{ backgroundColor: "var(--vz-secondary-bg)", top: '0px', transform: 'translateY(-50%)' }}>{t('Media')}</span>
                                    {
                                        (formik?.values?.media_ids || [])?.map((_m: any, indx: number) => (
                                            <div className="d-flex mb-3 p-2 position-relative" key={indx} style={{
                                                border: '1px solid #eaeaea',
                                                borderRadius: '4px',
                                            }}>
                                                <span className="text-secondary position-absolute fs-13 px-1" style={{ backgroundColor: "var(--vz-secondary-bg)", top: '0px', transform: 'translateY(-50%)' }}> {indx + 1}. {t('Media')}</span>
                                                <Row className="flex-grow-1 pt-2" >
                                                    <Col sm={6} md={4} className="mb-3 position-relative">
                                                        <Label htmlFor={`media_id_${indx}`} className="form-label">{t('Media')}<span className="text-danger"> *</span> </Label>
                                                        <DropdownOption
                                                            name={`media_id_${indx}`}
                                                            dataList={MEDIA_OPTIONS_LANG}
                                                            placeholder={`${t("Media")}...`}
                                                            className="search-filter-category-type dropdown-status-rounded"
                                                            classNamePrefix="name-prefix"
                                                            initialValue={_m || null}
                                                            isHaveMoreInfo={true}
                                                            onChangeSelect={(e: any) => {
                                                                formik.setFieldValue(`media_ids[${indx}]`, e)
                                                            }}
                                                            isHasOptionAll={false}
                                                            disabled={isDetailLoading}
                                                        />
                                                        {(formik.touched.media_ids as any)?.[indx] && formik.errors.media_ids?.[indx] ? (
                                                            <div className="text-danger mt-2">{formik.errors.media_ids?.[indx]}</div>
                                                        ) : null}
                                                    </Col>
                                                    <Col sm={6} md={4} className="mb-3 position-relative">
                                                        <Label htmlFor={`section_id_${indx}`} className="form-label">{t('Section')}<span className="text-danger"> *</span> </Label>
                                                        <DropdownOption
                                                            name={`section_id_${indx}`}
                                                            dataList={(_m?.partner_codes || [])?.map((_s: any) => ({ value: String(_s?.id), label: _s?.section_title }))}
                                                            placeholder={`${t("Section")}...`}
                                                            className="search-filter-category-type dropdown-status-rounded"
                                                            classNamePrefix="name-prefix"
                                                            initialValue={((formik?.values?.section_ids as any) || [])[indx] || null}
                                                            onChangeSelect={(e: any) => {
                                                                formik.setFieldValue(`section_ids[${indx}]`, e)
                                                            }}
                                                            isHasOptionAll={false}
                                                            disabled={isDetailLoading}
                                                        />
                                                        {(formik.touched.section_ids as any)?.[indx] && formik.errors.section_ids?.[indx] ? (
                                                            <div className="text-danger mt-2">{formik.errors.section_ids?.[indx] || ''}</div>
                                                        ) : null}
                                                    </Col>
                                                    <Col sm={6} md={4} className="mb-3 position-relative">
                                                        <Label htmlFor={`reporter_id_${indx}`} className="form-label">{t('Reporter ID')}</Label>
                                                        <Input
                                                            name={`reporter_id_${indx}`}
                                                            type="text"
                                                            className="form-control"
                                                            id={`reporter_id_${indx}`}
                                                            placeholder={t('Reporter ID')}
                                                            value={((formik?.values?.reporter_ids as any) || [])[indx] || ''}
                                                            onChange={(event: any) => formik.setFieldValue(`reporter_ids[${indx}]`, event?.target?.value)}
                                                        />

                                                        {(formik.touched.reporter_ids as any)?.[indx] && formik.errors.reporter_ids?.[indx] ? (
                                                            <div className="text-danger mt-2">{formik.errors.reporter_ids?.[indx] || ''}</div>
                                                        ) : null}
                                                    </Col>
                                                    {/* <Col sm={6} md={3} className="mb-3 position-relative">
                                                        <Label htmlFor={`reporter_by_line_${indx}`} className="form-label">{t('Byline')}</Label>
                                                        <Input
                                                            name={`reporter_by_line_${indx}`}
                                                            type="text"
                                                            className="form-control"
                                                            id={`reporter_by_line_${indx}`}
                                                            placeholder={t('Byline')}
                                                            value={((formik?.values?.reporter_by_lines as any) || [])[indx] || ''}
                                                            onChange={(event: any) => formik.setFieldValue(`reporter_by_lines[${indx}]`, event?.target?.value)}
                                                        />
                                                        {(formik.touched.reporter_ids as any)?.[indx] && formik.errors.reporter_ids?.[indx] ? (
                                                            <div className="text-danger mt-2">{formik.errors.reporter_ids?.[indx] || ''}</div>
                                                        ) : null}
                                                    </Col> */}
                                                    <Col sm={6} md={12} className="mb-3 position-relative align-self-end">
                                                        <div className="form-check form-switch mb-0">
                                                            <Input className="form-check-input"
                                                                type="checkbox"
                                                                role="switch"
                                                                id={`is_auto_publish_${indx}`}
                                                                name={`is_auto_publish_${indx}`}
                                                                checked={!!(((formik?.values?.is_auto_publishes as any) || [])[indx] || 0)}
                                                                onChange={(event: any) => {
                                                                    formik.setFieldValue(`is_auto_publishes[${indx}]`, Number(event?.target.checked))
                                                                }}
                                                            />
                                                            <Label htmlFor={`is_auto_publish_${indx}`} className="form-label mb-0">{t('Auto Publication')}
                                                                <TooltipCustom
                                                                    title={t("Only campaigns with Auto publication enabled will be sent to NewsHub. If Auto Publication is disabled, the media will not be assigned in Boosting News")}
                                                                    className="d-inline-block vertical-align-middle ms-1"
                                                                    style={{ transform: 'translateY(1px)' }}
                                                                >
                                                                    <i className="ri-question-line align-bottom text-secondary" ></i>
                                                                </TooltipCustom>
                                                            </Label>
                                                        </div>
                                                        {(formik.touched.is_auto_publishes as any)?.[indx] && formik.errors.is_auto_publishes?.[indx] ? (
                                                            <div className="text-danger mt-2">{formik.errors.is_auto_publishes?.[indx] || ''}</div>
                                                        ) : null}
                                                    </Col>
                                                </Row>
                                                <div className="position-absolute d-flex align-items-center justify-content-end justify-content-md-start" style={{ right: '8px', bottom: '8px' }} >
                                                    {(((formik?.values?.media_ids as any)?.length > 1)) && <button type="button" className="btn btn-md btn-soft-danger edit-item-btn"
                                                        onClick={(e: any) => { e.stopPropagation(); handleRemoveMedia(indx); }}
                                                    ><i className="ri-close-fill align-bottom"></i></button>
                                                    }
                                                    {((formik?.values?.media_ids as any)?.length === (indx + 1)) && <button type="button" className="btn btn-md btn-soft-success edit-item-btn ms-2"
                                                        onClick={(e: any) => { e.stopPropagation(); handleAddMedia(indx); }}
                                                    ><i className="ri-add-fill align-bottom"></i></button>}
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>

                                {/* <Col sm={12} md={12} xl={12} className='mb-3'>
                                    <div style={{ minHeight: '80px' }}>
                                        <label className="form-label">
                                            {t("Email")} ({t('Multi')})
                                            <TooltipCustom
                                                title={t("A notification email will be sent each time an article is created.")}
                                                className="d-inline-block vertical-align-middle ms-1"
                                                style={{ transform: 'translateY(1px)' }}
                                            >
                                                <i className="ri-question-line align-bottom text-secondary" ></i>
                                            </TooltipCustom>
                                        </label>
                                        <Hashtag
                                            name="emails"
                                            placeholder={`${t("Press Enter to add a new email")}...`}
                                            suggestions={[]}
                                            initialValue={formik?.values?.emails || []}
                                            onChangeTag={(event: any) => {
                                                formik.setFieldValue("emails", event);
                                            }}
                                            idSelected="hashtags-CampaignFormMulti"
                                            maxHashtags={2000}
                                            maxHeight="150px"
                                        />
                                    </div>
                                    {formik.touched.emails && formik.errors.emails ? (
                                        <div className="text-danger mt-2">{(formik.errors.emails?.[0] as any)?.text || ''}</div>
                                    ) : null}
                                </Col> */}

                                {/* {
                                    (formik.values.times || [])?.map((_t: any, indx: number) => (
                                        <div className="d-flex flex-grow-1" key={`${_t}_${indx}`}>
                                            <Col sm={12} md={4} lg={4} className="mb-3">
                                                <div>
                                                    <label className="form-label">
                                                        {t("Schedule")} {indx + 1}
                                                    </label>
                                                    <div className="date-picker-wrapper-custom">
                                                        <DatePicker
                                                            className="form-control search"
                                                            placeholderText={`${t("Schedule")}...`}
                                                            showTimeSelect
                                                            showTimeSelectOnly
                                                            timeIntervals={5}
                                                            autoComplete="off"
                                                            isClearable={true}
                                                            timeCaption={t("Time")}
                                                            timeFormat="HH:mm"
                                                            value={_t}
                                                            locale={i18n?.language === "ko" ? "ko" : "en"}
                                                            name={`time_${indx}`}
                                                            onChange={(value: Date | null) => {
                                                                formik.setFieldValue(`times[${indx}]`, value ? moment(new Date(value)).format("HH:mm") : "");
                                                            }}
                                                        />
                                                    </div>
                                                    {(formik.touched.times as any)?.[indx] && formik.errors.times?.[indx] ? (
                                                        <div className="text-danger mt-2">{formik.errors.times?.[indx] || ''}</div>
                                                    ) : null}
                                                </div>
                                            </Col>
                                            <div className="d-flex align-items-end justify-content-end mb-3" style={{ width: '60px', paddingBottom: (((formik.touched.times as any)?.[indx] && formik.errors.times?.[indx])) ? '28px' : '0px' }} >
                                                {(((formik?.values?.times as any)?.length > 1) && (formik?.values?.times as any)?.length !== (indx + 1)) && <button type="button" className="btn btn-md btn-soft-danger edit-item-btn"
                                                    onClick={(e: any) => { e.stopPropagation(); handleRemoveTime(indx); }}
                                                ><i className="ri-close-fill align-bottom"></i></button>
                                                }
                                                {((formik?.values?.times as any)?.length === (indx + 1)) && <button type="button" className="btn btn-md btn-soft-success edit-item-btn ms-3"
                                                    onClick={(e: any) => { e.stopPropagation(); handleAddTime(indx); }}
                                                ><i className="ri-add-fill align-bottom"></i></button>}
                                            </div>
                                        </div>
                                    ))
                                } */}

                                <div className="d-flex flex-column mb-2 pt-3 position-relative" style={{
                                    border: '1px dashed var(--vz-primary)',
                                    borderRadius: '4px',
                                }}>
                                    <span className="text-primary position-absolute fs-13 px-1" style={{ backgroundColor: "var(--vz-secondary-bg)", top: '0px', transform: 'translateY(-50%)' }}>{t('Content')}</span>

                                    <Col sm={12} className="mb-3">
                                        <Label htmlFor="ai_model" className="form-label">{t('AI Model')} <span className="text-danger"> *</span> </Label>
                                        <DropdownOption
                                            name="ai_model"
                                            dataList={AI_MODEL_OPTIONS_LANG || []}
                                            placeholder={`${t("AI Model")}...`}
                                            className={`dropdown-status-rounded z-hight`}
                                            classNamePrefix="name-prefix"
                                            initialValue={formik?.values?.ai_model || AI_MODEL_OPTIONS_LANG[1]}
                                            onChangeSelect={(e: any) => {
                                                formik.setFieldValue(`ai_model`, e)
                                            }}
                                        />
                                    </Col>

                                    <Col sm={12} className="mb-3">
                                        <Label htmlFor="ongoing_vote_prompt" className="form-label">{t('Prompt')} ({t('Ongoing Vote')})</Label>
                                        <Input
                                            name="text"
                                            type="textarea"
                                            className={`form-control`}
                                            placeholder={`${t('Prompt')}...`}
                                            rows={6}
                                            style={{ width: '100%', minHeight: '100px' }}
                                            value={formik?.values?.ongoing_vote_prompt}
                                            onChange={(event: any) => {
                                                formik.setFieldValue('ongoing_vote_prompt', event?.target?.value)
                                            }}
                                            autoComplete="off"
                                        />
                                        <div className="text-muted fs-12 mt-1">
                                            {t('Source data is labeled as ‘{content}’.')}
                                        </div>
                                        {formik.touched.ongoing_vote_prompt && formik.errors.ongoing_vote_prompt ? (
                                            <div className="text-danger mt-2">{formik.errors.ongoing_vote_prompt}</div>
                                        ) : null}
                                    </Col>

                                    <Col sm={12} className="mb-3">
                                        <Label htmlFor="completed_vote_prompt" className="form-label">{t('Prompt')} ({t('Ended Vote')})</Label>
                                        <Input
                                            name="text"
                                            type="textarea"
                                            className={`form-control`}
                                            placeholder={`${t('Prompt')}...`}
                                            rows={6}
                                            style={{ width: '100%', minHeight: '100px' }}
                                            value={formik?.values?.completed_vote_prompt}
                                            onChange={(event: any) => {
                                                formik.setFieldValue('completed_vote_prompt', event?.target?.value)
                                            }}
                                            autoComplete="off"
                                        />
                                        <div className="text-muted fs-12 mt-1">
                                            {t('Source data is labeled as ‘{content}’.')}
                                        </div>
                                        {formik.touched.completed_vote_prompt && formik.errors.completed_vote_prompt ? (
                                            <div className="text-danger mt-2">{formik.errors.completed_vote_prompt}</div>
                                        ) : null}
                                    </Col>
                                </div>

                                <div className="d-flex flex-column mb-2 pt-3 mt-3 position-relative" style={{
                                    border: '1px dashed var(--vz-primary)',
                                    borderRadius: '4px',
                                }}>
                                    <span className="text-primary position-absolute fs-13 px-1" style={{ backgroundColor: "var(--vz-secondary-bg)", top: '0px', transform: 'translateY(-50%)' }}>{t('Support Message')}</span>

                                    <Col sm={12} className="mb-3">
                                        <Label htmlFor="support_message_ai_model" className="form-label">{t('AI Model')} <span className="text-danger"> *</span> </Label>
                                        <DropdownOption
                                            name="support_message_ai_model"
                                            dataList={AI_MODEL_OPTIONS_LANG || []}
                                            placeholder={`${t("AI Model")}...`}
                                            className={`dropdown-status-rounded z-hight`}
                                            classNamePrefix="name-prefix"
                                            initialValue={formik?.values?.support_message_ai_model || AI_MODEL_OPTIONS_LANG[1]}
                                            onChangeSelect={(e: any) => {
                                                formik.setFieldValue(`support_message_ai_model`, e)
                                            }}
                                        />
                                    </Col>

                                    <Col sm={12} className="mb-3">
                                        <Label htmlFor="support_message_prompt" className="form-label">{t('Support Message AI Prompt')}</Label>
                                        <Input
                                            name="text"
                                            type="textarea"
                                            className={`form-control`}
                                            placeholder={`${t('Support Message AI Prompt')}...`}
                                            rows={6}
                                            style={{ width: '100%', minHeight: '100px' }}
                                            value={formik?.values?.support_message_prompt}
                                            onChange={(event: any) => {
                                                formik.setFieldValue('support_message_prompt', event?.target?.value)
                                            }}
                                            autoComplete="off"
                                        />
                                        <div className="text-muted fs-12 mt-1">
                                            {t('Source data is labeled as ‘{messages}’.')}
                                        </div>
                                        {formik.touched.support_message_prompt && formik.errors.support_message_prompt ? (
                                            <div className="text-danger mt-2">{formik.errors.support_message_prompt}</div>
                                        ) : null}
                                    </Col>
                                </div>

                                <div className="mt-3 mb-4" style={{ border: '1px dashed var(--vz-primary)', borderRadius: '4px', padding: '10px' }}>
                                    <span className="text-primary position-absolute fs-13 px-1" style={{ backgroundColor: "var(--vz-secondary-bg)", top: '0px', transform: 'translateY(-50%)' }}>{t('Schedule')}</span>
                                    <div>
                                        <Row className="mt-2">
                                            {/* <Col sm={4} md={3} lg={3} className="mb-3 position-relative">
                                                <Label htmlFor={`vote_type`} className="form-label">{t('Vote Type')}<span className="text-danger"> *</span> </Label>
                                                <DropdownOption
                                                    name={`vote_type`}
                                                    dataList={TYPE_VOTE_OPTIONS_LANG}
                                                    placeholder={`${t("Vote Type")}...`}
                                                    className="search-filter-category-type dropdown-status-rounded"
                                                    classNamePrefix="name-prefix"
                                                    initialValue={formik?.values?.vote_type || TYPE_VOTE_OPTIONS_LANG[0]}
                                                    onChangeSelect={(e: any) => {
                                                        formik.setFieldValue(`vote_type`, e)
                                                    }}
                                                    isHasOptionAll={false}
                                                />
                                                {formik.touched.vote_type && formik.errors.vote_type ? (
                                                    <div className="text-danger mt-2">{`${formik.errors.vote_type || ''}`}</div>
                                                ) : null}
                                            </Col> */}
                                            {/* <Col sm={4} md={3} lg={3} className="mb-3 position-relative">
                                                <Label htmlFor={`cycle_type`} className="form-label">{t('Voting Target')}<span className="text-danger"> *</span> </Label>
                                                <DropdownOption
                                                    name={`cycle_type`}
                                                    dataList={SCHEDULE_VOTE_OPTIONS_LANG}
                                                    placeholder={`${t("Voting Target")}...`}
                                                    className="search-filter-category-type dropdown-status-rounded"
                                                    classNamePrefix="name-prefix"
                                                    initialValue={formik?.values?.cycle_type || SCHEDULE_VOTE_OPTIONS_LANG[0]}
                                                    onChangeSelect={(e: any) => {
                                                        formik.setFieldValue(`cycle_type`, e)
                                                    }}
                                                    isHasOptionAll={false}
                                                />
                                                {formik.touched.cycle_type && formik.errors.cycle_type ? (
                                                    <div className="text-danger mt-2">{`${formik.errors.cycle_type || ''}`}</div>
                                                ) : null}
                                            </Col> */}

                                        </Row>
                                    </div>

                                    {
                                        (formik.values.create_schedules || [])?.map((_t: any, indx: number) => (
                                            <div className="row mt-2" key={`${_t?.type}_${indx}`}>
                                                <Col sm={4} md={3} lg={3} className="mb-3">
                                                    <div>
                                                        <label className="form-label">
                                                            {indx + 1}. {t("Schedule")}
                                                        </label>
                                                        <DropdownOption
                                                            name={`type_${indx}`}
                                                            dataList={SCHEDULE_OPTIONS_LANG}
                                                            placeholder={`${t("Schedule")}...`}
                                                            className="search-filter-category-type dropdown-status-rounded"
                                                            classNamePrefix="name-prefix"
                                                            initialValue={SCHEDULE_OPTIONS_LANG?.find((_sh: any) => String(_sh?.value) === String(_t?.type)) || null}
                                                            onChangeSelect={(e: any) => {
                                                                formik.setFieldValue(`create_schedules[${indx}]`, ({ ..._t, type: e?.value }))
                                                            }}
                                                            isHasOptionAll={false}
                                                            disabled={isDetailLoading}
                                                        />
                                                        {(formik.touched.create_schedules as any)?.[indx] && (formik.errors.create_schedules?.[indx] as any)?.type ? (
                                                            <div className="text-danger mt-2">{(formik.errors.create_schedules?.[indx] as any)?.type || ''}</div>
                                                        ) : null}
                                                    </div>
                                                </Col>
                                                <Col sm={4} md={3} lg={3} className="mb-3">
                                                    <div>
                                                        <label className="form-label">
                                                            {t("Day")} {_t?.type === ENUM_SCHEDULE.EVERY_WEEK && <span className="text-danger"> *</span>}
                                                        </label>
                                                        <DropdownOption
                                                            name={`date_${indx}`}
                                                            dataList={SCHEDULE_WEEKLY_OPTIONS_LANG}
                                                            placeholder={`${_t?.type === ENUM_SCHEDULE.EVERY_DAY ? t("Day") : t('Day of week')}...`}
                                                            className="search-filter-category-type dropdown-status-rounded"
                                                            classNamePrefix="name-prefix"
                                                            initialValue={(_t?.type === ENUM_SCHEDULE.EVERY_DAY) ? null : (SCHEDULE_WEEKLY_OPTIONS_LANG?.find((_sh: any) => String(_sh?.value) === String(_t?.date)) || SCHEDULE_WEEKLY_OPTIONS_LANG[0])}
                                                            onChangeSelect={(e: any) => {
                                                                formik.setFieldValue(`create_schedules[${indx}]`, ({ ..._t, date: e?.value }))
                                                            }}
                                                            isHasOptionAll={false}
                                                            disabled={isDetailLoading || (_t?.type === ENUM_SCHEDULE.EVERY_DAY)}
                                                        />
                                                        {(formik.touched.create_schedules as any)?.[indx] && (formik.errors.create_schedules?.[indx] as any)?.date ? (
                                                            <div className="text-danger mt-2">{(formik.errors.create_schedules?.[indx] as any)?.date || ''}</div>
                                                        ) : null}
                                                    </div>
                                                </Col>
                                                <Col sm={4} md={3} lg={3} className="mb-3">
                                                    <div>
                                                        <label className="form-label">
                                                            {t("Time")} <span className="text-danger"> *</span>
                                                        </label>
                                                        <div className="date-picker-wrapper-custom">
                                                            <DatePicker
                                                                className="form-control search"
                                                                placeholderText={`${t("Time")}...`}
                                                                showTimeSelect
                                                                showTimeSelectOnly
                                                                timeIntervals={5}
                                                                autoComplete="off"
                                                                isClearable={true}
                                                                timeCaption={t("Time")}
                                                                selected={_t?.time ? moment(_t.time, "HH:mm").toDate() : null}
                                                                minTime={new Date(0, 0, 0, 3, 0)}
                                                                maxTime={new Date(0, 0, 0, 23, 55)}
                                                                timeFormat="HH:mm"
                                                                value={_t?.time}
                                                                locale={i18n?.language === "ko" ? "ko" : "en"}
                                                                name={`time_${indx}`}
                                                                onChange={(value: Date | null) => {
                                                                    formik.setFieldValue(`create_schedules[${indx}]`, ({ ..._t, time: value ? moment(new Date(value)).format("HH:mm") : "" }));
                                                                }}
                                                            />
                                                        </div>
                                                        {(formik.touched.create_schedules as any)?.[indx] && (formik.errors.create_schedules?.[indx] as any)?.time ? (
                                                            <div className="text-danger mt-2">{(formik.errors.create_schedules?.[indx] as any)?.time || ''}</div>
                                                        ) : null}
                                                    </div>
                                                </Col>
                                                <Col sm={12} md={3} lg={3} className="d-flex align-items-end justify-content-end justify-content-md-start mb-3" style={{ paddingBottom: ((formik.touched.create_schedules as any)?.[indx] && !!(formik.errors.create_schedules?.[indx] as any)?.date) ? '28px' : '0px' }} >
                                                    {(((formik?.values?.create_schedules as any)?.length > 1)) && <button type="button" className="btn btn-md btn-soft-danger edit-item-btn"
                                                        onClick={(e: any) => { e.stopPropagation(); handleRemoveCreateSchedule(indx); }}
                                                    ><i className="ri-close-fill align-bottom"></i></button>
                                                    }
                                                    {((formik?.values?.create_schedules as any)?.length === (indx + 1)) && <button type="button" className="btn btn-md btn-soft-success edit-item-btn ms-2"
                                                        onClick={(e: any) => { e.stopPropagation(); handleAddCreateSchedule(indx); }}
                                                    ><i className="ri-add-fill align-bottom"></i></button>}
                                                </Col>
                                            </div>
                                        ))
                                    }
                                    {
                                        (formik.values.create_schedules || [])?.length === 0 && (
                                            <div className="d-flex flex-grow-1">
                                                <Col sm={6} md={4} lg={4} className="mb-3">
                                                    <div className="d-flex align-items-end justify-content-start mb-3" style={{ width: '45px', paddingBottom: '0px' }} >
                                                        <button type="button" className="btn btn-md btn-soft-success edit-item-btn ms-0"
                                                            onClick={(e: any) => { e.stopPropagation(); handleAddCreateSchedule(0); }}
                                                        ><i className="ri-add-fill align-bottom"></i></button>
                                                    </div>
                                                </Col>

                                            </div>
                                        )
                                    }
                                </div>
                                {/* <div className="mt-0 mb-4" style={{ border: '1px dashed var(--vz-primary)', borderRadius: '4px', padding: '10px' }}>
                                    <span className="text-primary position-absolute fs-13 px-1" style={{ backgroundColor: "var(--vz-secondary-bg)", top: '0px', transform: 'translateY(-50%)' }}>{t('Publishing Schedule')}</span>
                                    {
                                        (formik.values.publish_schedules || [])?.map((_t: any, indx: number) => (
                                            <div className="row mt-2" key={`${_t?.type}_${indx}`}>
                                                <Col sm={4} md={3} lg={3} className="mb-3">
                                                    <div>
                                                        <label className="form-label">
                                                            {t("Schedule")}
                                                        </label>
                                                        <DropdownOption
                                                            name={`type_${indx}`}
                                                            dataList={SCHEDULE_VOTE_OPTIONS_LANG}
                                                            placeholder={`${t("Schedule")}...`}
                                                            className="search-filter-category-type dropdown-status-rounded"
                                                            classNamePrefix="name-prefix"
                                                            initialValue={SCHEDULE_VOTE_OPTIONS_LANG?.find((_sh: any) => String(_sh?.value) === String(_t?.type)) || null}
                                                            onChangeSelect={(e: any) => {
                                                                formik.setFieldValue(`publish_schedules[${indx}]`, ({ ..._t, type: e?.value }))
                                                            }}
                                                            isHasOptionAll={false}
                                                            disabled={isDetailLoading}
                                                        />
                                                        {(formik.touched.publish_schedules as any)?.[indx] && (formik.errors.publish_schedules?.[indx] as any)?.type ? (
                                                            <div className="text-danger mt-2">{(formik.errors.publish_schedules?.[indx] as any)?.type || ''}</div>
                                                        ) : null}
                                                    </div>
                                                </Col>
                                                <Col sm={4} md={3} lg={3} className="mb-3">
                                                    <div>
                                                        <label className="form-label">
                                                            {t("Date")}
                                                        </label>
                                                        <DropdownOption
                                                            name={`date_${indx}`}
                                                            dataList={SCHEDULE_WEEKLY_OPTIONS_LANG}
                                                            placeholder={`${t("Date")}...`}
                                                            className="search-filter-category-type dropdown-status-rounded"
                                                            classNamePrefix="name-prefix"
                                                            initialValue={(_t?.type === VOTE_CYCLE_TYPE.WEEKLY) ? null : (SCHEDULE_WEEKLY_OPTIONS_LANG?.find((_sh: any) => String(_sh?.value) === String(_t?.date)) || null)}
                                                            onChangeSelect={(e: any) => {
                                                                formik.setFieldValue(`publish_schedules[${indx}]`, ({ ..._t, date: e?.value }))
                                                            }}
                                                            isHasOptionAll={false}
                                                            disabled={isDetailLoading || (_t?.type === VOTE_CYCLE_TYPE.WEEKLY)}
                                                        />
                                                        {(formik.touched.publish_schedules as any)?.[indx] && (formik.errors.publish_schedules?.[indx] as any)?.date ? (
                                                            <div className="text-danger mt-2">{(formik.errors.publish_schedules?.[indx] as any)?.date || ''}</div>
                                                        ) : null}
                                                    </div>
                                                </Col>
                                                <Col sm={4} md={3} lg={3} className="mb-3">
                                                    <div>
                                                        <label className="form-label">
                                                            {t("Time")}
                                                        </label>
                                                        <div className="date-picker-wrapper-custom">
                                                            <DatePicker
                                                                className="form-control search"
                                                                placeholderText={`${t("Time")}...`}
                                                                showTimeSelect
                                                                showTimeSelectOnly
                                                                timeIntervals={5}
                                                                autoComplete="off"
                                                                isClearable={true}
                                                                timeCaption={t("Time")}
                                                                timeFormat="HH:mm"
                                                                value={_t?.time}
                                                                locale={i18n?.language === "ko" ? "ko" : "en"}
                                                                name={`time_${indx}`}
                                                                onChange={(value: Date | null) => {
                                                                    formik.setFieldValue(`publish_schedules[${indx}]`, ({ ..._t, time: value ? moment(new Date(value)).format("HH:mm") : "" }));
                                                                }}
                                                            />
                                                        </div>
                                                        {(formik.touched.publish_schedules as any)?.[indx] && (formik.errors.publish_schedules?.[indx] as any)?.time ? (
                                                            <div className="text-danger mt-2">{(formik.errors.publish_schedules?.[indx] as any)?.time || ''}</div>
                                                        ) : null}
                                                    </div>
                                                </Col>
                                                <Col sm={12} md={3} lg={3} className="d-flex align-items-end  justify-content-end justify-content-md-start mb-3" style={{ paddingBottom: !!(formik.errors.publish_schedules?.[indx]) ? '28px' : '0px' }} >
                                                    {(((formik?.values?.publish_schedules as any)?.length > 1) && (formik?.values?.publish_schedules as any)?.length !== (indx + 1)) && <button type="button" className="btn btn-md btn-soft-danger edit-item-btn"
                                                        onClick={(e: any) => { e.stopPropagation(); handleRemovePublishSchedule(indx); }}
                                                    ><i className="ri-close-fill align-bottom"></i></button>
                                                    }
                                                    {((formik?.values?.publish_schedules as any)?.length === (indx + 1)) && <button type="button" className="btn btn-md btn-soft-success edit-item-btn"
                                                        onClick={(e: any) => { e.stopPropagation(); handleAddPublishSchedule(indx); }}
                                                    ><i className="ri-add-fill align-bottom"></i></button>}
                                                </Col>
                                            </div>
                                        ))
                                    }
                                </div> */}



                                {/* <Col sm={12} md={12} xl={12} className="mb-4">
                                    <Label htmlFor="formSizeDefault" className="form-label">{t('Image')} <span className="text-danger"> *</span></Label>
                                    <div className="d-flex gap-3 flex-wrap">
                                        {
                                            (formik.values.image_urls || [])?.map((img: any, index: number) => (
                                                <div className="position-relative" style={{ width: '200px', height: '200px', backgroundColor: '#eaeaea', overflow: 'hidden', borderRadius: 'var(--vz-border-radius)' }}>
                                                    <img
                                                        src={img?.url}
                                                        alt={`preview-${index}`}
                                                        style={{ width: "100%", height: "100%", objectFit: 'cover' }}
                                                    />
                                                    <button type="button" className="position-absolute btn btn-sm btn-soft-danger edit-item-btn"
                                                        style={{
                                                            top: '10px',
                                                            right: '10px',
                                                            width: '30px',
                                                            height: '30px',
                                                            borderRadius: '15px',
                                                        }}
                                                        onClick={() => handleDeleteImageUrl(index)}
                                                    ><i className="ri-delete-bin-3-fill align-bottom"></i></button>
                                                </div>
                                            ))
                                        }
                                        {
                                            (formik.values.files || [])?.map((file: any, index: number) => (
                                                <div className="position-relative" style={{ width: '200px', height: '200px', backgroundColor: '#eaeaea', overflow: 'hidden', borderRadius: 'var(--vz-border-radius)' }}>
                                                    <img
                                                        src={URL.createObjectURL(file)}
                                                        alt={`preview-${index}`}
                                                        style={{ width: "100%", height: "100%", objectFit: 'cover' }}
                                                    />
                                                    <button type="button" className="position-absolute btn btn-sm btn-soft-danger edit-item-btn"
                                                        style={{
                                                            top: '10px',
                                                            right: '10px',
                                                            width: '30px',
                                                            height: '30px',
                                                            borderRadius: '15px',
                                                        }}
                                                        onClick={() => handleDeleteFile(index)}
                                                    ><i className="ri-delete-bin-3-fill align-bottom"></i></button>
                                                </div>
                                            ))
                                        }
                                        <div className="custom-file-image-button">
                                            <Input
                                                className="form-control"
                                                accept="image/jpeg, image/png, image/gif, image/webp, image/svg+xml"
                                                label="Upload Your Image"
                                                data-title="Upload Your Image"
                                                id="formSizeDefault"
                                                type="file"
                                                multiple
                                                disabled={isLoading}
                                                onChange={handleChangeFile}
                                            />
                                            {<div className="text-upload" style={{ zIndex: 1 }}>  <i className="ri-upload-line me-2" /> {formik.values.files?.length ? t('Add Image') : t('No file chosen')}</div>}
                                        </div>
                                    </div>
                                    {formik.touched.files && formik.errors.files ? (
                                        <div className="text-danger mt-2">{formik.errors.files}</div>
                                    ) : null}
                                </Col> */}


                                <Col sm={12} className="mb-2 mt-4" >
                                    <div className="d-flex gap-3 justify-content-end align-item-center">
                                        <button
                                            className="btn btn-primary fs-14 px-1 d-flex justify-content-center align-item-center"
                                            type="submit"
                                            style={{ width: '160px' }}
                                            disabled={isLoading}
                                        >
                                            {isLoading && <span style={{ transform: 'translateY(1px)' }} className="me-1"><Spinner size="sm"></Spinner></span>}<span>{
                                                !!detail?.id ? t('Button Update Campaign') : t('Button Create Campaign')
                                            }</span>
                                        </button>
                                        <button
                                            className="btn btn-secondary fs-14 px-1 d-flex justify-content-center align-item-center"
                                            type="button"
                                            onClick={onCloseClick}
                                            style={{ width: '75px' }}
                                        >
                                            <i className="ri-close-fill" style={{ lineHeight: '22px' }} /> <span className="ms-1">{t("Button Close")}</span>
                                        </button>
                                    </div>
                                </Col>
                            </Row>
                        </form>
                    </div>
                </ModalBody>
            </Modal>
            <Modal
                isOpen={!!isShowPreviewJSON}
                centered={true}
                size="lg"
                scrollable={true}
                toggle={() => setIsShowPreviewJSON(() => false)}
            >
                <ModalHeader toggle={() => setIsShowPreviewJSON(() => false)}>
                    <>{t("Preview the sample source data JSON")}</>
                </ModalHeader>
                <ModalBody className="pt-3 pb-0">
                    <JSONPretty id="json-pretty" data={jsonSources}></JSONPretty>
                </ModalBody>
                <ModalFooter>
                    <div className="d-flex justify-content-center align-item-center">
                        <button
                            className="btn btn-secondary"
                            type="button"
                            onClick={() => setIsShowPreviewJSON(() => false)}
                            style={{ width: '100px' }}
                        >
                            <i className="ri-close-fill" style={{ lineHeight: '22px' }} /> <span className="ms-1">{t("Button Close")}</span>
                        </button>
                    </div>
                </ModalFooter>
            </Modal>
        </React.Fragment >
    );
};

export default CampaignForm;

